import React from "react";
import { Modal } from "../components";
import { Panel } from "../components/panels";
import TwoColumnLayout from "../layout/TwoColumnLayout";
import BrandInfoPanel from "./BrandInfoPanel";
import FinishedBrandInfoPanel from "./FinishedBrandInfoPanel";
import LinkToUserPanel from "./LinkToUser/LinkToUserPanel";
import OtherFilesPanel from "./OtherFilesPanel";
import SignModal, { type SignValue } from "./SignModal";
import ViewDocumentInline from "./ViewDocumentInline";
import { useViewport } from "utilities/hookutils";
import { useLoaderData } from "react-router";

interface Props {
  viewModel: server.viewmodel.ESignLandingFrontModel
}

const App = () => {
  const [displaySignModal, setDisplaySignModal] = React.useState(false);
  const viewport = useViewport();
  const viewModel = useLoaderData<server.viewmodel.ESignLandingFrontModel>();

  const onSignClicked = async (signValue: SignValue) => {
    return window.CoreApi.ESignOpen.PlaceSignature(
      viewModel.secret,
      {
        signatureSvg: signValue.svg,
        signatureFileId: signValue.fileGuid
      });
  };

  const documentSigningCompleted = viewModel.status.value === "successDocumentComplete";

  const renderContent = () => {
    return <>
      {!documentSigningCompleted && <BrandInfoPanel
        brand={viewModel.brand}
        message={viewModel.message}
        participantCanSign={viewModel.participantCanSign}
        invitationBody={viewModel.invitationBody}
        onSignClicked={() => { setDisplaySignModal(true); }}
        signedUtc={viewModel.participant?.signature?.signedUtc}
        missingSignatures={viewModel.missingSignatures}
        documentUrl={viewModel.completedFileUrl}
      />}
      {documentSigningCompleted && <FinishedBrandInfoPanel
        brand={viewModel.brand}
        message={viewModel.message}
        invitationBody={viewModel.invitationBody}
        completedUtc={viewModel.completedUtc}
        docUrl={viewModel.completedFileUrl}
      />}

      {viewModel.otherFiles.length > 0 && <OtherFilesPanel
        secret={viewModel.secret}
        otherFiles={viewModel.otherFiles}
      />}

      <LinkToUserPanel
        suggestedUserDetails={viewModel.suggestedUserDetails}
        secret={viewModel.secret}
        participant={viewModel.participant}
      />

      {site.debug && <DebugPanel viewModel={viewModel} />}
      <Modal
        isOpen={displaySignModal}
        handleClose={() => { setDisplaySignModal(false); }}
        title={RESX.ESign.SignThisDocument}
        width="tiny"
      >
        <SignModal
          secret={viewModel.secret}
          signeeName={viewModel.signeeName}
          onSignClicked={onSignClicked}
          hasFinishedSigning={() => { window.location.reload(); }}
        />
      </Modal>
    </>;
  };

  if (viewport === "mobile") {
    return renderContent();
  }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ViewDocumentInline
        documentUrl={viewModel.completedFileUrl}
        onSignClicked={() => { setDisplaySignModal(true); }}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn size="medium">
      {renderContent()}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

const DebugPanel = (props: Props) => {
  return <Panel
    title={"Debug"}
    panelClassName="s1_related-feature-panel"
  >
    Sent to: {props.viewModel.suggestedUserDetails.name.fullName}<br />
    {(props.viewModel.participant.linkedToUser != null) ? `linked to ${props.viewModel.participant.linkedToUser.fullName}` : "not linked to user"}
  </Panel >;
};

export default App;